// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2NQEK","forms":"Login_forms__36aZJ"};